export const NoteColor = {
  Yellow: 'yellow',
  Pink: 'pink',
  Blue: 'blue',
  Green: 'green',
  Purple: 'purple',
  Orange: 'orange',
} as const;

export type NoteColor = (typeof NoteColor)[keyof typeof NoteColor];

export const NOTE_COLORS: readonly NoteColor[] = Object.values(NoteColor);

export function isNoteColor(value: unknown): value is NoteColor {
  return typeof value === 'string' && (NOTE_COLORS as readonly string[]).includes(value);
}
